import { render } from "./IncidenciaAdmin.vue?vue&type=template&id=3d303f77&scoped=true"
import script from "./IncidenciaAdmin.vue?vue&type=script&lang=js"
export * from "./IncidenciaAdmin.vue?vue&type=script&lang=js"

import "./IncidenciaAdmin.vue?vue&type=style&index=0&id=3d303f77&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d303f77"]])

export default __exports__